import styled from 'styled-components';

export const Container = styled.div`
  background: var(--color-resume-container-blue);
  display: flex;
  color: #e4e4e4;
  justify-content: center;
  text-align: center;
  align-items: center;
  font-size: 12px;
`;
export const Wrapper = styled.div`
  margin-right: 5rem;
`;
